import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setPortal } from 'modules/portal';
import { makeRowColumn, getHeadObj, dataConverter } from 'lib/commonLib';
import { dailyAllParTotal } from 'lib/api/time';
import { paramConverter } from 'modules/common';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

import AllParStatisticsGraph from './AllParStatisticsGraph';
import moment from 'moment';

const AllParStatistics = () => {
  const initParams = {
    pltfomTpCode: 'all',
    itlTpCode: 'all',
    sort: 'desc',
    order: 'STATS_DTTM',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
  };

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  // const childColumnSet = {
  //   STATS_DTTM: () => {
  //     return null;
  //   },
  // };
  //
  // /**
  //  * 테이블 클릭 후 세부정보 받아올때 보낼 param setting 해주는 함수
  //  * @param {json} data 테이블 로우 데이터
  //  */
  // const makeSubParam = (data) => {
  //   return {
  //     statsDttm: data.STATS_DTTM,
  //   };
  // };

  // header 및 body 컬럼 커스텀
  const customized = {
    STATS_DTTM: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'STATS_DTTM').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const statsDttm = getHeadObj(headsMap, 'STATS_DTTM');

        const convertKeys = [
          'sDate',
          'eDate',
          'advrtsPrdtCode',
          'advrtsTpCode',
          'pltfomTpCode',
          'itlTpCode',
        ];
        let addParams = dataConverter(params, convertKeys, 'string');
        const showWindowUrl =
          '/report/media?isPop=1&uri=/report/media' + addParams;
        const dateValue = makeRowColumn(
          rowObj['STATS_DTTM'],
          'date',
          'YYYY-MM-DD'
        );

        var dayOfWeek = new Date(dateValue).getDay();
        let resultComponent;

        let dayColor;
        if (dayOfWeek === 0) {
          dayColor = 'red';
        } else if (dayOfWeek === 6) {
          dayColor = 'blue';
        }

        if (rowObj.isChild) {
          resultComponent = (
            <>
              {makeRowColumn(
                rowObj['STATS_DTTM'],
                statsDttm.type,
                statsDttm.format
              )}
            </>
          );
        } else {
          const dateValue = makeRowColumn(
            rowObj['STATS_DTTM'],
            'date',
            'YYYY-MM-DD'
          );

          resultComponent = (
            <IconAreaWrap
              text={makeRowColumn(
                rowObj['STATS_DTTM'],
                statsDttm.type,
                statsDttm.format
              )}
              textColor={dayColor}
              icon={dateValue !== 'total' && 'faExternalLink'}
              toolTipTitle={t('해당 날짜의 매체별 통계')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
            />
          );
        }
        return resultComponent;
      },
    },
    ORDER_CNT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'ORDER_CNT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const orderCnt = getHeadObj(headsMap, 'ORDER_CNT');
        const showWindowUrl =
          '/report/conversion/state_list?sDate=' +
          rowObj['STATS_DTTM'] +
          '&eDate=' +
          rowObj['STATS_DTTM'] +
          '&uri=/report/conversion/state_list&isPop=1';
        let resultComponent;
        if (rowObj.isChild) {
          resultComponent = (
            <>
              {makeRowColumn(
                rowObj['ORDER_CNT'],
                orderCnt.type,
                orderCnt.format
              )}
            </>
          );
        } else {
          const dateValue = makeRowColumn(
            rowObj['STATS_DTTM'],
            'date',
            'YYYY-MM-DD'
          );

          resultComponent = (
            <IconAreaWrap
              text={makeRowColumn(
                rowObj['ORDER_CNT'],
                orderCnt.type,
                orderCnt.format
              )}
              icon={dateValue !== 'total' && 'faExternalLink'}
              toolTipTitle={t('해당 날짜의 컨버전 리스트')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
            />
          );
        }
        return resultComponent;
      },
    },
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          pltfomTpCodeDetailFilter={['04']}
        />
      </NewFilterWrap>

      <AllParStatisticsGraph params={{ ...paramConverter(params) }} />
      <NewTableContainer
        dataReqPromise={dailyAllParTotal}
        params={{ ...params }}
        getParam={getParam}
        customized={customized}
        useTotal={false}
        useSearch={false}
        expandTable
      />
    </>
  );
};

export default AllParStatistics;
